import React from 'react';
import CopyButton from '../../../../components/CopyButton';
import { typography, palette } from '../../../../utils/designTokens';
import { logger } from '../../../../utils/logger';

const SpanAttributesSection = ({ span }) => {
  if (!span) {
    throw new Error('SpanAttributesSection requires span prop');
  }

  logger.debug('SpanAttributesSection rendering:', span.span_id);

  const formatTimestamp = (ts) => {
    if (!ts) return 'N/A';
    try {
      return new Date(ts).toLocaleString();
    } catch (e) {
      logger.error('Failed to format timestamp:', ts, e);
      return 'Invalid';
    }
  };

  return (
    <div className="space-y-1.5">
      <div className="flex justify-between items-center">
        <span className={`${typography.size.xs} font-mono`} style={{ color: palette.support.attributeLabel }}>Span ID</span>
        <div className="flex items-center gap-2">
          <span className={`${typography.size.xs} font-mono text-accent-teal truncate max-w-[150px]`} title={span.span_id}>
            {span.span_id}
          </span>
          <CopyButton text={span.span_id} size="xs" label="Copy Span ID" />
        </div>
      </div>
      <div className="flex justify-between items-center">
        <span className={`${typography.size.xs} font-mono`} style={{ color: palette.support.attributeLabel }}>Status</span>
        <span className={`${typography.size.xs} font-mono text-accent-teal`}>
          {span.status_code === 'UNSET' ? 'OK' : (span.status_code || 'OK')}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className={`${typography.size.xs} font-mono`} style={{ color: palette.support.attributeLabel }}>Start</span>
        <span className={`${typography.size.xs} font-mono text-accent-teal`} title={span.start_time}>
          {formatTimestamp(span.start_time)}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className={`${typography.size.xs} font-mono`} style={{ color: palette.support.attributeLabel }}>End</span>
        <span className={`${typography.size.xs} font-mono text-accent-teal`} title={span.end_time}>
          {formatTimestamp(span.end_time)}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className={`${typography.size.xs} font-mono`} style={{ color: palette.support.attributeLabel }}>Duration</span>
        <span className={`${typography.size.xs} font-mono text-accent-teal`}>
          {span.duration_ms ? `${span.duration_ms.toFixed(2)} ms` : 'N/A'}
        </span>
      </div>
    </div>
  );
};

export default SpanAttributesSection;
